import React from 'react';
import { bunnyAboutData } from '../../bunnyMock';
import { Zap, Star, Heart } from 'lucide-react';

const BunnyAboutSection = () => {
  return (
    <section id="about" className="section-spacing bunny-section-light">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl sm:text-6xl font-serif bunny-headline text-gray-900 mb-4">
            {bunnyAboutData.headline}
          </h2>
          <div className="bunny-divider mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left column - Story */}
          <div className="space-y-6">
            <p className="text-lg text-gray-700 font-sans leading-relaxed">
              {bunnyAboutData.story}
            </p>
            <p className="text-lg text-gray-700 font-sans leading-relaxed">
              {bunnyAboutData.mission}
            </p>
          </div>

          {/* Right column - Difference */}
          <div className="bunny-card p-10">
            <div className="flex items-start gap-4 mb-8">
              <div className="p-4 bunny-bg-pink rounded-full">
                <Zap className="w-8 h-8 text-white" />
              </div>
              <div>
                <h3 className="text-3xl font-serif bunny-headline text-gray-900 mb-4">
                  The Waisted Bunny Difference
                </h3>
                <p className="text-base text-gray-700 font-sans leading-relaxed font-semibold">
                  {bunnyAboutData.difference}
                </p>
              </div>
            </div>

            <div className="space-y-4 mt-8">
              <div className="flex items-center gap-3 p-3 bg-gray-50 border-l-4 border-pink-400">
                <Star className="w-5 h-5 bunny-accent-pink flex-shrink-0" />
                <span className="text-gray-900 font-sans font-bold">Bold, Trend-Driven Designs</span>
              </div>
              <div className="flex items-center gap-3 p-3 bg-gray-50 border-l-4 border-pink-400">
                <Heart className="w-5 h-5 bunny-accent-pink flex-shrink-0" />
                <span className="text-gray-900 font-sans font-bold">Fashion-Forward Philosophy</span>
              </div>
              <div className="flex items-center gap-3 p-3 bg-gray-50 border-l-4 border-pink-400">
                <Zap className="w-5 h-5 bunny-accent-pink flex-shrink-0" />
                <span className="text-gray-900 font-sans font-bold">Premium Quality, Always</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BunnyAboutSection;
